import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_b8755750 from 'nuxt_plugin_head_b8755750' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_341671e2 from 'nuxt_plugin_plugin0_341671e2' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_3416e641 from 'nuxt_plugin_plugin1_3416e641' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_34175aa0 from 'nuxt_plugin_plugin2_34175aa0' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_3417ceff from 'nuxt_plugin_plugin3_3417ceff' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_3418435e from 'nuxt_plugin_plugin4_3418435e' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_3418b7bd from 'nuxt_plugin_plugin5_3418b7bd' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_34192c1c from 'nuxt_plugin_plugin6_34192c1c' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_3419a07b from 'nuxt_plugin_plugin7_3419a07b' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_341a14da from 'nuxt_plugin_plugin8_341a14da' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_341a8939 from 'nuxt_plugin_plugin9_341a8939' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_4ec5e8bd from 'nuxt_plugin_plugin10_4ec5e8bd' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_4ec65d1c from 'nuxt_plugin_plugin11_4ec65d1c' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_4ec6d17b from 'nuxt_plugin_plugin12_4ec6d17b' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_4ec745da from 'nuxt_plugin_plugin13_4ec745da' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_4ec7ba39 from 'nuxt_plugin_plugin14_4ec7ba39' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_4ec82e98 from 'nuxt_plugin_plugin15_4ec82e98' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_4ec8a2f7 from 'nuxt_plugin_plugin16_4ec8a2f7' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_4ec91756 from 'nuxt_plugin_plugin17_4ec91756' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_4ec98bb5 from 'nuxt_plugin_plugin18_4ec98bb5' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_4eca0014 from 'nuxt_plugin_plugin19_4eca0014' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_4ed4003e from 'nuxt_plugin_plugin20_4ed4003e' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_4ed4749d from 'nuxt_plugin_plugin21_4ed4749d' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_4ed4e8fc from 'nuxt_plugin_plugin22_4ed4e8fc' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_4ed55d5b from 'nuxt_plugin_plugin23_4ed55d5b' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_4ed5d1ba from 'nuxt_plugin_plugin24_4ed5d1ba' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_b8755750 === 'function') {
    await nuxt_plugin_head_b8755750(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_341671e2 === 'function') {
    await nuxt_plugin_plugin0_341671e2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_3416e641 === 'function') {
    await nuxt_plugin_plugin1_3416e641(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_34175aa0 === 'function') {
    await nuxt_plugin_plugin2_34175aa0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_3417ceff === 'function') {
    await nuxt_plugin_plugin3_3417ceff(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_3418435e === 'function') {
    await nuxt_plugin_plugin4_3418435e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_3418b7bd === 'function') {
    await nuxt_plugin_plugin5_3418b7bd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_34192c1c === 'function') {
    await nuxt_plugin_plugin6_34192c1c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_3419a07b === 'function') {
    await nuxt_plugin_plugin7_3419a07b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_341a14da === 'function') {
    await nuxt_plugin_plugin8_341a14da(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_341a8939 === 'function') {
    await nuxt_plugin_plugin9_341a8939(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_4ec5e8bd === 'function') {
    await nuxt_plugin_plugin10_4ec5e8bd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_4ec65d1c === 'function') {
    await nuxt_plugin_plugin11_4ec65d1c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_4ec6d17b === 'function') {
    await nuxt_plugin_plugin12_4ec6d17b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_4ec745da === 'function') {
    await nuxt_plugin_plugin13_4ec745da(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_4ec7ba39 === 'function') {
    await nuxt_plugin_plugin14_4ec7ba39(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_4ec82e98 === 'function') {
    await nuxt_plugin_plugin15_4ec82e98(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_4ec8a2f7 === 'function') {
    await nuxt_plugin_plugin16_4ec8a2f7(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_4ec91756 === 'function') {
    await nuxt_plugin_plugin17_4ec91756(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_4ec98bb5 === 'function') {
    await nuxt_plugin_plugin18_4ec98bb5(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_4eca0014 === 'function') {
    await nuxt_plugin_plugin19_4eca0014(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_4ed4003e === 'function') {
    await nuxt_plugin_plugin20_4ed4003e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_4ed4749d === 'function') {
    await nuxt_plugin_plugin21_4ed4749d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_4ed4e8fc === 'function') {
    await nuxt_plugin_plugin22_4ed4e8fc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_4ed55d5b === 'function') {
    await nuxt_plugin_plugin23_4ed55d5b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_4ed5d1ba === 'function') {
    await nuxt_plugin_plugin24_4ed5d1ba(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
